import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import "./Form.css";


const Form = ({ inverseColors }) => {
    const [isAgreed, setIsAgreed] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [isSent, setIsSent] = useState(false);
    const { t } = useTranslation();

    const idSubmitBtnDisabled = !isAgreed || !email || !message;

    useEffect(() => {
        if (!isSent) {
            return undefined;
        }

        const timeoutId = setTimeout(() => {
            setEmail('');
            setMessage('');
            setIsAgreed(false);
            setIsSent(false);
        }, 3000);

        return () => clearTimeout(timeoutId);
    }, [isSent]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSent(true);

        fetch('https://itdrs.tech/sendMessage/',{
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-type": "application/json"
            },
            body: JSON.stringify(
                {from: email, message: message, agree: isAgreed}
            )
        }).catch(() => {});
    }

    return (
        <div className={`${isSent && 'form-transition-sent'} form-transition`}>
            <form className='form-content' onSubmit={handleSubmit}>
                <div className='form-item-wrapper'>
                <span className={`${!inverseColors && 'form-item-header-white'} form-item-header`}>{t('E-mail')}</span>
                <input
                    className={`${!inverseColors && 'form-item-input-black'} form-item-input`}
                    required
                    type='email'
                    placeholder={t('Write your e-mail address')}
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                />
                </div>
                <div className='form-item-wrapper'>
                <span className={`${!inverseColors && 'form-item-header-white'} form-item-header`}>{t('Comment')}</span>
                <textarea
                    rows={5}
                    className={`${!inverseColors && 'form-item-input-black'} form-item-input`}
                    required
                    placeholder={t('Write your message')}
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                />
                </div>
                <div className='form-item-wrapper form-item-block'>
                <label className="custom-checkbox">
                    <input
                        type='checkbox'
                        className={`${!inverseColors && 'form-item-checkbox-black'} form-item-checkbox`}
                        checked={isAgreed}
                        onChange={(e) => setIsAgreed(e.target.checked)}
                    />
                    <span className="checkmark"></span>
                </label>
                <span
                    className={`
                        ${!inverseColors && 'form-item-header-white'} 
                        form-item-header 
                        form-item-checkbox-descr
                        ${isAgreed && 'form-item-checkbox-active'}`
                    }
                >
                    {t('I agree to transmit data for feedback')}
                </span>
                </div>
                <button
                    className={`${!inverseColors && 'form-item-btn-white'} form-item-btn`}
                    disabled={idSubmitBtnDisabled}
                >
                    {t('Send')}
                </button>
            </form>
            <p className={`${!inverseColors && 'form-success-message-white'} form-success-message`}>
                Thank you for your message.
                <br />
                We shall contact you shortly.
            </p>
        </div>
    )
}

export default Form;
